import {
  Component,
  Event,
  EventEmitter,
  getAssetPath,
  h,
  Host,
  Prop,
  Element,
} from '@stencil/core';

import wcShared from '@web-components/shared';

import helpdeskCommon from '../../../../../../utils/HelpdeskCommon.class';
import { InitStore } from '../../../../../../utils/Stores/init-store';
import { Store } from '../../../../../../utils/Stores/store';

@Component({
  tag: 'bot-message-component',
  styleUrl: 'bot-message-module.scss',
  shadow: true,
})
export class ModuleBotMessage {
  @Prop() readonly message: IWCChatMessage;
  @Prop() readonly lastMessage: { total: number; index: number };

  @Element() el: HTMLBotMessageComponentElement;

  @Event() messagesEnded: EventEmitter<number>;

  componentDidLoad() {
    // Scroll to the bottom of the chat once the component has loaded
    this.messagesEnded.emit(500);
  }

  componentWillRender() {
    helpdeskCommon.hasScroll();
  }

  componentDidUpdate() {
    // Scroll down to the lastest message when the app update
    if (this.lastMessage && this.lastMessage.total === this.lastMessage.index) {
      this.el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  render() {
    const { id, first_name, last_name, avatar_url } = InitStore?.get('init')?.user || {};
    const name = `${first_name} ${last_name}`;

    return (
      <Host>
        <div
          class={{
            'chat-message': true,
            'chat-message--left': this.message?.sender_type === 'bot' || !Boolean(this.message),
            'chat-message--right': this.message?.sender_type === 'customer',
            'chat-message--full': Store?.get('is_full'),
          }}
        >
          <div class={{ 'chat-message__user': true, hide: this.message?.hide_sender }}>
            {this.message?.sender_type === 'customer' ? (
              Boolean(id) ? (
                <module-avatar-component
                  name={name}
                  size={26}
                  fontSize={12}
                  accountId={id}
                  logo={avatar_url}
                ></module-avatar-component>
              ) : (
                <img
                  src={Store?.get('userAvatar')?.url}
                  alt=""
                />
              )
            ) : (
              <img
                class="chat-message__user--avatar"
                src={getAssetPath('./../assets/beep/' + Store?.get('beepAvatar')?.url)}
                alt=""
              />
            )}
            <span>
              {this.message?.sender_type === 'customer'
                ? wcShared?.translate('Vous')
                : Store?.get('beepAvatar')?.name}
            </span>
          </div>
          <div
            class={{ 'chat-message__message': true, 'margin-bottom-20': this.message?.hide_time }}
          >
            <div>
              <bot-message-switch-component
                lastMessage={this.lastMessage}
                message={this.message}
              ></bot-message-switch-component>
              {this.message?.messages?.map((item) => {
                return (
                  <bot-message-switch-component
                    lastMessage={this.lastMessage}
                    message={item}
                    style={{ 'margin-top': '10px', display: 'block' }}
                  ></bot-message-switch-component>
                );
              })}
            </div>
          </div>
          <div
            class={{
              'chat-message__time': true,
              hide: !Boolean(this.message?.created_at) || Boolean(this.message?.hide_time),
            }}
          >
            {wcShared?.store?.pipes?.formatDate(this.message?.created_at, 'HH:mm')}
          </div>
        </div>
      </Host>
    );
  }
}
